<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-form
          :size="$store.state.buttonSize"
          label-width="140px"
          style="display:inline; height:36px; margin-right:20px"
        >
          <el-form-item label="设置生成数量：" prop="checkItemsId">
            <el-select v-model="num" style="width:100px" placeholder="请选择生成数量">
              <el-option key="10" label="10" value="10"></el-option>
              <el-option key="20" label="20" value="20"></el-option>
              <el-option key="50" label="50" value="50"></el-option>
              <el-option key="100" label="100" value="100"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" :size="$store.state.buttonSize" :loading="createBtnLoading" @click="qrCodeCreate"  :disabled="isDisabled">{{ createBtnText }}</el-button>
        <el-button type="primary" :size="$store.state.buttonSize" @click="batchPrint" :disabled="!selectionID.length">批量打印</el-button>
        <RemoveButton
          type="info"
          :size="$store.state.buttonSize"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="溯源码模糊查询"
          :size="$store.state.buttonSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :selectable="selectable" :disabled="true" width="55"></el-table-column>
      <el-table-column prop="barcode" label="商品条码"></el-table-column>
      <el-table-column prop="batchCode" label="批次编码"></el-table-column>
      <el-table-column prop="traceCode" label="溯源码"></el-table-column>
      <el-table-column prop="isPrint" label="是否打印">
        <template slot-scope="scope">
          <template v-if="scope.row.isPrint === 0">
            <el-tag type="success">否</el-tag>
          </template>
          <template v-else>
            <el-tag type="info">是</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="qrModalOpen(scope.row.traceCode)">查看</el-button>
          <template v-if="scope.row.isPrint === 0">
            <el-button type="text" @click="qrCodeDel(scope.row.id)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    ></pagination>
    <!-- 查看二维码 -->
    <Dialog title="二维码" :visible.sync="qrModalVisible" center width="50%">
      <QrModal :bCode="bCode" :pCode="pCode" :tCode="tCode" />
    </Dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import QrModal from './QrModal'
import {
  getQrCodeList,
  delQrCodeList,
  deleteQrCodeDel,
  putQrCodeAdd,
  postQrCodeEdit,
  getQrCodeListPrint
} from '@/api/qrcode'

export default {
  components: {
    QrModal
  },
  data() {
    return {
      selectionID: [],
      checkItemsList: [],
      checkFormVisible: false,
      qrModalVisible: false,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      num: 10,
      currentID: null,
      loading: true,
      tableData: [],
      createBtnText: '批量生成',
      createBtnLoading: false,
      bCode: '',
      pCode: '',
      tCode: ''
    }
  },
  props: {
    batchId: Number,
    batchCode: String,
    barcode: String
  },
  watch: {
    prop(batchId, batchCode, barcode) {
      console.log(batchId)
      console.log(batchCode)
      console.log(barcode)
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑批次' : '新增批次'
    }
  },
  created() {
    console.log(this.batchCode)
    console.log(this.barcode)
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceSubmit = debounce(300, this.batchSubmit)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delQrCodeList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getQrCodeListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    selectable(row, index) {
      if (row.isPrint === 1) {
        return false
      } else {
        return true
      }
    },
    // 打开二维码
    qrModalOpen(traceCode) {
      this.qrModalVisible = true
      this.bCode = this.batchCode
      this.pCode = this.barcode
      this.tCode = traceCode
    },
    // 批量打印
    batchPrint() {
      // if (this.selectionID.length >= 20) {
      //   this.$message.error('最多一次打印20张')
      //   return
      // }
      getQrCodeListPrint({
        batchCode: this.batchCode,
        barcode: this.barcode,
        ids: this.selectionID
      }).then(res => {
        if (res.status === 1) {
          console.log(res)
          window.sessionStorage.setItem('printList', JSON.stringify(res.data))
          const routeData = this.$router.resolve({
            name: '/print'
          })
          window.open(routeData.href, '_blank')
          this.$confirm('是否打印成功?', '打印结果确认', {
            confirmButtonText: '成功',
            cancelButtonText: '失败',
            type: 'warning'
          }).then(() => {
            postQrCodeEdit({
              batchCode: this.batchCode,
              barcode: this.barcode,
              ids: this.selectionID
            }).then(res => {
              if (res.status === 1) {
                this.$message.success('打印成功')
                this.getQrCodeListData()
              } else {
                this.$message.error(res.msg)
                return false
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '如打印出现问题，请重新打印。'
            })
          })
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getQrCodeListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getQrCodeListData()
    },
    // 删除二维码
    qrCodeDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteQrCodeDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getQrCodeListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量生成二维码
    qrCodeCreate() {
      this.createBtnLoading = true
      this.isDisabled = true
      this.createBtnText = '生成中...'
      setTimeout(() => {
        this.isDisabled = false
      }, 2000)
      putQrCodeAdd({
        batchCode: this.batchCode,
        barcode: this.barcode,
        num: this.num
      }).then(res => {
        if (res.status === 1) {
          this.$message.success('二维码生成成功')
          this.createBtnLoading = false
          this.createBtnText = '批量生成'
          this.getQrCodeListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 检索
    search() {
      this.getQrCodeListData()
    },
    // 刷新数据表格
    refresh() {
      this.getQrCodeListData()
      this.$message.success('数据刷新成功')
    },
    // 获取二维码列表
    getQrCodeListData() {
      this.loading = true
      getQrCodeList({
        page: this.page,
        size: this.size,
        batchCode: this.batchCode,
        barcode: this.barcode,
        traceCode: this.keywords
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    console.log(this.batchCode, this.barcode)
    this.getQrCodeListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss">
.tabel-bar-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
